import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ApiResponse,
  ICreateRole,
  IDeleteRole,
  ILimit,
  IRole,
  IUpdateRole,
  SelectedRole,
} from '@/services/role/role.type';

export interface UserRoleState {
  roles: ApiResponse;
  loading: boolean;
  error: boolean;
  SelectedRole: SelectedRole;
}

export const initialState: UserRoleState = {
  roles: {
    data: [],
    pagination: {
      totalRecords: 0,
      currentPage: 0,
      totalPages: 0,
      nextPage: 0,
      previousPage: 0,
    },
    success: false,
    message: '',
  },
  loading: false,
  error: false,
  SelectedRole: { name: '', id: '' },
};

const userRoleSlice = createSlice({
  name: 'userRole',
  initialState,
  reducers: {
    getUsersRole: (state, action: PayloadAction<ILimit>) => {
      state.loading = true;
    },
    getUsersRoleSuccess: (state, action: PayloadAction<ApiResponse>) => {
      state.loading = false;
      state.roles = { ...action.payload };
    },
    getUsersRoleFailure: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.error = true;
    },
    createUserRole: (state, action: PayloadAction<ICreateRole>) => {
      state.loading = true;
    },
    createUserRoleSuccess: (state, action: PayloadAction<IRole>) => {
      state.loading = false;
      state.roles = { ...action.payload } as unknown as ApiResponse; // Avoid direct assignment, create a new object
    },
    createUserRoleFailure: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.error = true;
    },
    updateUserRole: (state, action: PayloadAction<IUpdateRole>) => {
      state.loading = true;
    },
    updateUserRoleSuccess: (state, action: PayloadAction<IRole>) => {
      state.loading = false;
      state.roles = { ...action.payload } as unknown as ApiResponse; // Avoid direct assignment, create a new object
    },
    updateUserRoleFailure: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.error = true;
    },
    deleteUserRole: (state, action: PayloadAction<IDeleteRole>) => {
      state.loading = true;
    },
    deleteUserRoleSuccess: (state, action: PayloadAction<IRole>) => {
      state.loading = false;
      state = {
        ...state,
        roles: {
          ...state.roles,
          data: state.roles.data.filter(
            (item) => item.roleId !== action.payload.roleId,
          ),
        },
      }; // Avoid direct assignment, create a new object
    },
    deleteUserRoleFailure: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.error = true;
    },
  },
});

const userRoleReducer = userRoleSlice.reducer;
export const {
  getUsersRole,
  getUsersRoleSuccess,
  getUsersRoleFailure,
  createUserRole,
  createUserRoleSuccess,
  createUserRoleFailure,
  updateUserRole,
  updateUserRoleFailure,
  updateUserRoleSuccess,
  deleteUserRole,
  deleteUserRoleSuccess,
  deleteUserRoleFailure,
} = userRoleSlice.actions;
export default userRoleReducer;
